import * as styles from "./CollapsibleContent.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { Collapsible as BaseCollapsible } from "@base-ui/react/collapsible";

import type { CollapsibleContentProps } from "./Collapsible.types";

export function CollapsibleContent({
  className,
  ...props
}: CollapsibleContentProps): JSX.Element {
  return (
    <BaseCollapsible.Panel
      data-slot="collapsible-content"
      className={clsx(styles.content, className)}
      {...props}
    />
  );
}
